import { useEffect, useState } from "react";
import style from './Activity.module.css';

const formatTime = (seconds) => {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  return `${hrs}h ${mins}m ${secs}s`;
};

const Activity = ({ activity, message, page }) => {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const itemsPerPage = 150;

  useEffect(() => {
    setIsLoading(true);
    setUsers(activity);
    setFilteredUsers(activity);
    setIsLoading(false);
    // console.log("Activity data loaded", activity);
  }, [activity, page]);

  const handleInputvalue = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSearch = () => {
    if (searchTerm) {
      const filtered = users.filter(user => user.phone.includes(searchTerm));
      setFilteredUsers(filtered);
      setCurrentPage(1);
    } else {
      setFilteredUsers(users);
    }
  };

  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);

  const exportToCSV = () => {
    const headers = ["Phone", "Book Name", "Last Played Time"];
    const rows = filteredUsers.flatMap(user => 
      user.booksWithPlayback.map((book, bookIndex) => [
        bookIndex === 0 ? user.phone : "", // Only include the phone number for the first entry
        `"${book.bookName.replace(/"/g, '""')}"`, // Escape double quotes in book names
        formatTime(book.lastPlaybackTime),
      ])
    );
  
    let csvContent = headers.join(",") + "\n"; // Add headers
    rows.forEach(row => {
      csvContent += row.join(",") + "\n";
    });
  
    const encodedUri = "data:text/csv;charset=utf-8," + encodeURIComponent(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "user_activity.csv");
    document.body.appendChild(link); // Required for Firefox
    link.click();
    document.body.removeChild(link);
  };
  

  return (
    <>
      <h2>Check User Activity</h2>
      <div className={style.subdiv}>
        {message && <p>{message}</p>}
        <div className="d-flex">
          <input
            value={searchTerm}
            placeholder="Enter user phone number"
            onChange={handleInputvalue}
            className="form-control m-3"
          />
          <button onClick={handleSearch} className="btn btn-secondary m-3">Search</button>
          <button onClick={exportToCSV} className="btn btn-secondary m-3">
                  Export to CSV
                </button>
        </div>
        {isLoading ? (
          <div className="d-flex justify-content-center">
            <div className="spinner-border" role="status">
            </div>
          </div>
        ) : (
          <>
            {currentUsers.length > 0 ? (
              <>
                {/* <button onClick={exportToCSV} className="btn btn-primary mt-3">
                  Export to CSV
                </button> */}
                {currentUsers.map((user, index) => (
                  <div key={index} className={style.eachdiv}>
                    <strong>Phone:</strong> {user.phone}
                    <br />
                    <strong>Books Played:</strong>
                    <ul>
                      {user.booksWithPlayback.map((book, bookIndex) => (
                        <li key={bookIndex}>
                          <strong>Book Name:</strong> {book.bookName} -
                          <strong> Last Played:</strong> {formatTime(book.lastPlaybackTime)}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
                <div className="container">
                  <div className="pagination">
                    <button onClick={prevPage} disabled={currentPage === 1}>Previous</button>
                    {[...Array(totalPages)].map((_, index) => (
                      <button
                        key={index}
                        onClick={() => paginate(index + 1)}
                        className={currentPage === index + 1 ? 'active' : ''}
                      >
                        {index + 1}
                      </button>
                    ))}
                    <button onClick={nextPage} disabled={currentPage === totalPages}>Next</button>
                  </div>
                </div>

              </>
            ) : (
              <p>No user activity found.</p>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default Activity;
